document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".field-wrapper-icon").forEach((toggleIcon) => {
        const inputId = toggleIcon.getAttribute("data-input-id");
        if (inputId) {
            const passwordInput = document.getElementById(inputId) as HTMLInputElement;
            if (passwordInput) {
                toggleIcon.addEventListener("click", () => {
                    const isPassword = passwordInput.type === "password";
                    passwordInput.type = isPassword ? "text" : "password";

                    // Zmiana ikony w zależności od statusu
                    toggleIcon.setAttribute("data-visible", isPassword ? "true" : "false");
                });
            }
        }
    });
});
